<div class="tw:relative tw:flex tw:min-h-10 tw:items-center tw:justify-between tw:gap-5">
  <div class="tw:overflow-hidden">
    <h1
      class="tw:typography-headline-2 tw:block tw:overflow-hidden tw:text-ellipsis tw:text-nowrap tw:text-white tw:min-[745px]:typography-headline-1"
    >
      <ng-content select="[title]"></ng-content>
    </h1>
  </div>

  <div class="tw:flex tw:items-center tw:gap-2.5">
    @if (actions?.template(); as template) {
      <ng-container [ngTemplateOutlet]="template" />
    }

    <ng-content select="[right]"></ng-content>

    <!-- `max-[745px]` (width < 745) is the exact complement of the mobile slot's `min-[745px]`:
         with `max-[744px]` both slots showed at 744px. -->
    <div class="tw:flex tw:items-center tw:gap-2.5 tw:empty:hidden tw:max-[745px]:hidden">
      <ng-content select="[right-desktop]"></ng-content>
    </div>

    <div class="tw:flex tw:items-center tw:gap-2.5 tw:empty:hidden tw:min-[745px]:hidden">
      <ng-content select="[right-mobile]"></ng-content>
    </div>
  </div>
</div>
